import React from 'react';

const Loading = ({open, children}) => {
  return (
    <div
            id="modal-component"
            className={`
                        fixed inset-0 flex z-50 justify-center items-center transition-colors bg-[rgba(0,0,0,0.8)]
                        ${open ? "visible" : "invisible"}
                    `}
        >
            <div
                className="bg-transparent"
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
  );
}

export default Loading;
